<template>
    <div class="youtube-player-wrapper">
        <div class="border">
            <div class="youtube-player">
                <iframe
                    v-if="youtubeSrc"
                    ref="playerIframe"
                    :src="youtubeSrc"
                    frameborder="0"
                    allow="autoplay; encrypted-media" allowfullscreen>
                </iframe>
                <img v-else src="../assets/confused.gif" alt="missing">
            </div>
            <div class="arrow">
                <Sub_VideoPLayerSVG></Sub_VideoPLayerSVG>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref }  from 'vue'
import { useRoute }                     from 'vue-router'
import Sub_VideoPLayerSVG               from './Sub_VideoPLayerSVG.vue'
import apiClient                        from '@/api'

const route         = useRoute()
const playlistId    = ref('')
const youtubeSrc    = ref('')

let autoplayTimeout = null

const buildYouTubeURL = (id) => {
    return `https://www.youtube.com/embed?listType=playlist&list=${id}&autoplay=1&loop=1&mute=1&controls=0&rel=0&modestbranding=1&iv_load_policy=3&playlist=${id}`
}

const fetchYoutubePlaylist = async (screen) => {
    try {
        const response   = await apiClient.get('get_youtube_playlist/', { params: { title: screen } })
        playlistId.value = response.data.data
        youtubeSrc.value = buildYouTubeURL(playlistId.value)

        // Refresh l'autoplay
        autoplayTimeout = setTimeout(recoverAutoplay, 1500)
    } catch (e) {
        console.error('Failed to fetch playlist:', e)
    }
}

// Essaie de refresh l'autoplay
const recoverAutoplay = () => {
    const iframe = document.querySelector('iframe')
    if (!iframe) return

    // Refresh la source afin de forcer l'autoplay
    const src = iframe.src
    iframe.src = ''
    setTimeout(() => {
        iframe.src = src
    }, 300)
}

onMounted(() => {
    fetchYoutubePlaylist(route.params.screen)
})

onUnmounted(() => {
    if (autoplayTimeout) clearTimeout(autoplayTimeout)
})
</script>


<style lang="scss" scoped>
.youtube-player-wrapper {
    box-sizing: border-box;

    margin-top: 3.5rem;
}

.border {
    border: 4px solid $orange;
    padding: 1rem;
    border-radius: calc(10px + 1rem);

    position: relative;

    .arrow {
        position: absolute;

        top: -60px;
        right: -90px;
    }
}

.youtube-player {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    overflow: hidden;
    border-radius: 10px;
}

.youtube-player iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    display: block;
}

.youtube-player img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>
